// Of het animatielab op dit moment open mag staan.
//
// Deze vlag staat bewust alleen in het geheugen van de pagina: bij een
// refresh - of bij het aanzetten van de Raspberry Pi - begint hij weer op
// false, en dan stuurt het lab je direct terug naar het dashboard. De tv
// komt zo nooit na een herstart in het testscherm terecht, ook niet als de
// browser de laatste URL onthoudt.

let unlocked = false;

export const unlockLab = () => {
  unlocked = true;
};

export const lockLab = () => {
  unlocked = false;
};

export const labUnlocked = () => unlocked;
